import styled from 'styled-components';

export const CardAssetContainer = styled.div<{ withAdjustedMargin: boolean }>`
  display: flex;
  justify-content: center;
  filter: drop-shadow(0px 5px 20px rgba(0, 0, 0, 0.08));
  position: relative;
  margin-top: ${({ withAdjustedMargin }) => (withAdjustedMargin ? -26 : 0)}px;
`;

export const CardImage = styled.img`
  filter: drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.08));
`;
